import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoLanguage } from 'react-icons/io5';
import { LuUsers2 } from 'react-icons/lu';
import { MdOutlineTableBar } from 'react-icons/md';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from 'src/app/store';
import LanguageSwitchLink from 'src/components/LangSwitch';
import { useInitSession } from 'src/hook/useInitSession';
import { ELanguages } from 'src/shared/enum';
import styles from 'src/styles/Nav.module.css';

const listNav = [
  {
    iconComponent: <IoLanguage className="cursor-pointer" fontSize={22} />,
    name: 'Lang',
    defaultPath: '/lang',
    pathNames: ['lang'],
  },
];

export default function HomeScreen() {
  const {
    categories,
    loadOrderStatus,
    fullOrder,
    submittingStatus,
    shopId,
    tables,
  } = useAppSelector(state => state.order);
  const {guests, table_id} = fullOrder?.table ?? {}
  const [openLangs, setOpenLangs] = useState<boolean>(false);
  const pName = useLocation().pathname.split('/').reverse()[0];

  const { t } = useTranslation(['main']);

  const currentTabIndex = listNav.findIndex(item =>
    item.pathNames.includes(pName),
  );

  const navigate = useNavigate();
  const pathParams = useParams();

  const { language } = useTranslation(['main']).i18n;

  const _ = useInitSession();

  const handleClickIcon = (itemPath: string) => {
    navigate(itemPath);
  };

  const onLangBtn = (e: any) => {
    e.stopPropagation();
    setOpenLangs(!openLangs);
  };

  const nameLanguage = (lang: string) => {
    switch (lang) {
      case 'en':
        return 'English';
      case 'cn':
        return 'Chinese';
      default:
        return 'English';
    }
  };

  const handleStartOrder = () => {
    navigate({
      pathname: `/order/${shopId}/index`,
    });
  };

  const ImageComponent: React.FC = () => (
    <img
      src="/food_dark.jpg"
      className={`h-1/3 w-full opacity-10 object-cover`}
      alt=""
    />
  );

  return (
    <div className="h-full w-full fixed top-0 flex items-center justify-center overflow-hidden">
      <div className="fixed top-0 h-full bg-primary bg-gradient-to-bl from-primary via-primary to-secondary/40  w-full"></div>
      <div className="absolute h-full w-full">
        {[0, 1, 2].map(index => (
          <ImageComponent key={index} />
        ))}
      </div>
      <div className="fixed top-[28px] left-[20px] flex flex-row gap-[20px] justify-center px-[15px] text-[16px] font-bold mb-5 text-white">
        <div className="flex gap-[10px] items-center justify-center">
          <MdOutlineTableBar fontSize={20} />
          <p>{table_id}</p>
        </div>
        <div className="flex gap-[10px] items-center justify-center">
          <LuUsers2 fontSize={20} />
          <p>{guests}</p>
        </div>
      </div>
      <div className="font-medium flex justify-start items-center text-white border-[1px] border-white rounded-[10px] p-2 fixed top-[20px] right-[20px]" onClick={e => onLangBtn(e)
            }>
        {listNav.map((item, index) => (
          <div
            className={`relative flex flex-col justify-center items-center 
                      sm:hover:text-primary sm:cursor-pointer ${
                        index === currentTabIndex && 'text-primary'
                      }`}
            key={index}>
            <IoLanguage className="text-white mr-[5px]" fontSize={20} />
            {item.name === 'Lang' && (
              <div
                className={`xl:top-10 xl:absolute border rounded-[12px]
                            ${styles.hiddenLang} ${
                              openLangs ? styles.dropdownLang : 'xl:hidden'
                            } `}>
                <div className={`flex`}>
                  {Object.values(ELanguages).map(lang => (
                    <LanguageSwitchLink key={lang} locale={lang} />
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
        <p className="text-[16px]">{nameLanguage(language)}</p>
      </div>
      <div className="font-medium text-center flex flex-col items-center overflow-hidden gap-[50px] mt-[-80px] z-10">
        <div className="">
          <img
            src="/defaultImage.jpeg"
            alt="defaultimage"
            className="w-[150px] rounded-md object-cover"
          />
        </div>
        {loadOrderStatus == 'error' ? (
          <div className="mt-[70px]">
            Your order code is past the time limit, please ask for a new one.
          </div>
        ) : categories && categories.length ? (
          <div
            className="px-8 py-2 bg-black/30 text-[20px] font-medium text-white rounded-[20px]"
            onClick={handleStartOrder}>
            {t('startOrder')}
          </div>
        ) : undefined}
      </div>
      <div className="fixed bottom-0 bg-black w-full text-white h-[30px] flex gap-[10px] justify-center items-center">
        <img src="/logo_gold.png" alt="defaultimage" className="w-[18px]" />
        Partnered with EARN
      </div>
    </div>
  );
}
